import { User } from '@nimmsta/ng-commons-lib';

export interface QRResponse {
  createdAt: Date;
  lastUpdatedAt: Date;
  id: string;
  qrCode: string;
  user: User;
  expiresAt: Date;
  status: QRStatus;
}

export enum QRStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  USED = 'USED',
}
